module.exports = __webpack_public_path__ + "media/images/article/sum03-6aa309361acbbc69ddda501b59fb818e.png";